import {
    CartItemInput,
    CartItemInterface,
    Maybe,
    ProductInterface
} from '@pylot-data/pylotschema'
import { CartData } from '../use-cart'
import { processItemPrice } from './optimisticAddToCart/processItemPrice'
import { processConfigurableItem } from './optimisticAddToCart/processConfigurableItem'
import { processGiftCardItem } from './optimisticAddToCart/processGiftCardItem'
import { findCartItem } from './optimisticAddToCart/findCartItem'
import { getGrandTotal } from './optimisticAddToCart/getGrandTotal'

export const getOptimisticAddToCartData = (
    cartData: CartData | null | undefined,
    cartItems: CartItemInput[],
    products: ProductInterface[]
): CartData => {
    const cart = cartData?.data?.cart
    const items = [...(cart?.items || [])]
    cartItems.forEach((cartItem, idx) => {
        const itemSku = cartItem.parent_sku ?? cartItem.sku
        const product = products.find(
            (productItem) => productItem.sku === itemSku
        )
        if (!product) {
            return
        }

        let item: Maybe<CartItemInterface> | undefined = findCartItem(
            items,
            cartItem.selected_options,
            itemSku
        )
        if (item) {
            item.quantity += cartItem.quantity
        } else {
            // We don't know the item ID/UID yet, so we are using index in the array instead
            item = {
                product,
                id: String(idx),
                uid: String(idx),
                quantity: cartItem.quantity
            }
            items.push(item)
        }
        processItemPrice(item, product.price_range.minimum_price)
        processConfigurableItem(cartItem, item, product)
        processGiftCardItem(cartItem, item, product)
    })

    const updatedGrandTotal = getGrandTotal(items, cart?.prices?.grand_total)

    return {
        data: {
            cart: {
                ...cart,
                items,
                prices: {
                    ...cart?.prices,
                    grand_total: updatedGrandTotal,
                    subtotal_excluding_tax: updatedGrandTotal
                }
            },
            isOptimistic: true
        }
    }
}
